export enum QuickSortStep {
  QuickSortInit,
  QuickSortCall,
  QuickSortEntry,
  QuickSortCompareLowHigh,
  QuickSortCallPartition,

  PartitionEntry,
  PartitionAssignPivot,
  PartitionAssignICount,
  PartitionAssignJCount,
  PartitionLoopCompareJCountHI,
  PartitionLoopCompareJCountPivot,
  PartitionLoopIncrementICount,
  PartitionLoopSwapICountJCount,
  PartitionLoopIncrementJCount,
  PartitionSwapPivotICount,
  PartitionReturnPivot,

  QuickSortAssignPartitionIndex,
  QuickSortLeftRecursionCall,
  QuickSortRightRecursionCall,

  QuickSortReturn
}